import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { addError, clearError } from './Error';
import { listProducts } from '../Api/Product/ProductApi';

export interface Product {
  id: string;
  sf_id: string;
  name: string;
  family?: string;
  productcode?: string;
  isactive?: boolean;
}

const productsSubject = new BehaviorSubject<Product[]>([] as Product[]);
const productsLoadingSubject = new BehaviorSubject<boolean>(false);
export const getProductsSubject = (): BehaviorSubject<Product[]> => productsSubject;
export const getProductsLoadingSubject = (): BehaviorSubject<boolean> => productsLoadingSubject;

export const fetchProducts = async () => {
  productsLoadingSubject.next(true);

  const { data, error } = await listProducts();

  if (data) {
    clearError('product');
    productsSubject.next(data);
  }
  if (error) addError('product', error.message);

  productsLoadingSubject.next(false);
};
